<svg width="24"
     height="24"
     viewBox="0 0 24 24"
     fill="none"
     xmlns="http://www.w3.org/2000/svg"
     aria-hidden="true"
     focusable="false">

      <path d="M13 18L7.70711 12.7071C7.31658 12.3166 7.31658 11.6834 7.70711 11.2929L13 6"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round" />

</svg>